import PromiseForm from './PromiseForm';

export default PromiseForm;
